/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferBatchesControllerPatchBatchMutationRequest, TransferBatchesControllerPatchBatchMutationResponse, TransferBatchesControllerPatchBatchPathParams, TransferBatchesControllerPatchBatch400, TransferBatchesControllerPatchBatch401, TransferBatchesControllerPatchBatch403, TransferBatchesControllerPatchBatch404 } from "../../models/transferBatchesController/TransferBatchesControllerPatchBatch";

function getTransferBatchesControllerPatchBatchUrl(id: TransferBatchesControllerPatchBatchPathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/transfer-batches/${id}` as const }  
  return res
}

/**
 * @summary Perform an action on a transfer batch
 * {@link /api/v1/transfer-batches/:id}
 */
export async function transferBatchesControllerPatchBatch(id: TransferBatchesControllerPatchBatchPathParams["id"], data?: TransferBatchesControllerPatchBatchMutationRequest, config: Partial<RequestConfig<TransferBatchesControllerPatchBatchMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TransferBatchesControllerPatchBatchMutationResponse, ResponseErrorConfig<TransferBatchesControllerPatchBatch400 | TransferBatchesControllerPatchBatch401 | TransferBatchesControllerPatchBatch403 | TransferBatchesControllerPatchBatch404>, TransferBatchesControllerPatchBatchMutationRequest>({ method : "PATCH", url : getTransferBatchesControllerPatchBatchUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}